<template lang="pug">
.sidebar(:class="{'is-collapse': isCollapse}")
  .sidebar__footer(v-if="!isCollapse")
    .sidebar__user(@click="$router.push('/user/info')")
      img(
        v-if="userLogo"
        :src="userLogo"
        style="width: 20px; transform: translateY(2px); margin-right: 3px"
      )
      img(
        v-else
        src="@/umcc/assets/shape.png"
        style="width: 12px; transform: translateY(2px); margin-right: 3px"
      )
      el-tooltip(
        v-if="userName.length > 50"
        :content="userName"
        placement="top"
      )
        span {{ userName }}
      span(v-else) {{ userName }}
    .sidebar__signout(@click="handleSignOut") {{ $t('登出') }}

  .sidebar__logo
    img(src="@/umcc/assets/logo_big.png" :class="{'transparent': isCollapse}" style="width: 80%")
    img(src="@/umcc/assets/logo_small.svg" :class="{'transparent': !isCollapse}" style="width: 50px")
  sidebar-item(
    v-for="(item, index) in processedMenu"
    :key="index"
    :item="item"
    :level="0"
    @change="onChange"
  )
</template>

<script>
import axios from 'axios'
import SidebarItem from '@/components/SidebarItem'

export default {
  data () {
    return {
      activePath: this.$route.path
    }
  },
  computed: {
    userName () {
      if (!this.$store.getters.user) return ''
      return this.$store.getters.user.user_name
    },
    userLogo () {
      if (!this.$store.getters.user) return null
      return this.$store.getters.user.logo_url
    },
    isCollapse () {
      return this.$store.state.common.isCollapse
    },
    menu () {
      return this.$store.getters.menuRoutes
    },
    processedMenu () {
      // output: {processedMenu, active}
      // 函数接收`menu`，返回`processed menu`，设置其中每个`item`的`_active`属性，使得`MenubarItem`组件可以根据这个属性来渲染
      const process = (menu, activePath) => {
        if (menu == null) {
          return {
            children: undefined,
            active: false
          }
        }

        const processed = menu.map((item) => {
          const { processed: subProcessed, active: subActive } = process(
            item.children,
            activePath
          )
          let active = item.path === activePath || subActive
          if (item.active && item.active.test(activePath)) {
            active = true
          }
          return {
            ...item,
            children: subProcessed,
            _active: active
          }
        })

        return {
          processed,
          active: processed.some(c => c._active), // eslint-disable-line
        }
      }

      return process(this.menu, this.activePath).processed
    }
  },
  watch: {
    $route () {
      this.activePath = this.$route.path
    }
  },
  methods: {
    handleSignOut () {
      axios.get('/signout').then(res => {
        this.$store.commit('common/setUser', null)
        location.href = '/login'
      })
    },
    onChange (routeName) {
      if (!routeName) return
      if (routeName === '/campaign/list') {
        this.$store.commit('campaign/setCampaignListKeyword', '')
        this.$store.commit('campaign/setCampaignListPageNumber', 1)
        this.$store.commit('campaign/setCampaignListVendorId', null)
        this.$store.commit('campaign/setCampaignListBrandId', null)
      }
      this.$router.push({
        path: routeName,
        query: {
          t: +new Date()
        }
      })
    }
  },
  components: {
    SidebarItem
  }
}
</script>

<style lang="stylus" scoped>
.sidebar
  position relative
  width 200px
  background-color #26272c
  transition all 0.3s linear
  > .sidebar-item
    font-size: 16px

.sidebar.is-collapse
  width 80px
  .iconfont
    margin-left 10px
  .sidebar__logo img
  .el-tooltip i
  .el-submenu__title i
    padding-left 5px

.sidebar__logo
  height 100px
  background #184a93
  position relative
  img
    position:absolute;
    left:0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    &.transparent
      opacity 0

.sidebar__item
  color #fff
  padding 20px
  cursor pointer
  display flex
  align-items center
  font-weight bold
  transition all 0.3s ease
  white-space nowrap
  overflow hidden
  &.active
    background-color #7796bb
  &:hover
    background-color #7796bb
  .iconfont
    margin-right 10px
    font-weight normal

.sidebar__footer
  position absolute
  bottom 50px
  left 12px

.sidebar__signout
  width 125px
  height 40px
  border-radius 4px
  background-image linear-gradient(to left, #6fa7ba, #61a8eb 34%, #3370d2)
  font-size 16px
  text-align center
  margin-left 25px
  color #fff
  line-height 43px
  cursor pointer

.sidebar__user
  font-size 16px
  margin-left 32px
  margin-bottom 30px
  color #fff
  cursor pointer
  span
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
    display inline-block
    width 120px
    vertical-align bottom
</style>
